import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m160 32-21.3 64H0v384h512V96H373.3L352 32zm96 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192"
    }, null, -1)
  ])))
}
export default { render: render }